import { useEffect, useState, useRef } from "react";
import { confirmDeleteInvitedUser, getInvitedUsers } from "../../services/authService";
import { getCookie } from "../../utils/cookieUtil";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const LoadingSpinner = () => (
  <div className="fixed inset-0 flex h-full items-center justify-center  bg-opacity-50 z-50">
    <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
  </div>
);


function InvitedUsers({ counter, selectedIds, setSelectedIds, searchMailQuery, selectedGroup, reload,onExportRef }) {
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [loading, setDataLoading] = useState(false);
  const [permission, setPermission] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);



  const dropdownRef = useRef(null);

  const itemsPerPage = 10;

  const navigate = useNavigate();

  useEffect(() => {
    setCurrentPage(1);
  }, [searchMailQuery]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedGroup]);

  useEffect(() => {
    fetchInvitedUsers();
  }, [counter, searchMailQuery, selectedGroup, reload]);



  useEffect(() => {
    const roles = getCookie("roleId");
    if (roles) {
      setPermission(`${roles}`);
    }
  }, []);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);



  


  const fetchInvitedUsers = async () => {
    setDataLoading(true);
    try {
      const res = await getInvitedUsers();
      const data = await res.json();
      setInvitedUsers(data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setDataLoading(false);
    }
  };

  const handleDeleteClick = (uid) => {
    setUserToDelete(uid);
    setShowConfirmationModal(true);
  };

  const confirmDelete = async () => {
    try {
      setDataLoading(true);
      setShowConfirmationModal(false);
      await confirmDeleteInvitedUser(userToDelete);
      setUserToDelete(null);
      fetchInvitedUsers();
    } catch (error) {
      console.error("Failed to delete user:", error);
    } finally {
      setDataLoading(false);
    }
  };


  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setUserToDelete(null);
  };


  const filteredUsers = invitedUsers.filter((user) => {
    const emailMatch = user?.email?.toLowerCase().includes(searchMailQuery.toLowerCase());
    const groupMatch = selectedGroup && selectedGroup !== "All Groups"
      ? user?.group?.toLowerCase().includes(selectedGroup.toLowerCase())
      : true;
    return emailMatch && groupMatch;
  });

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);




  const handleViewClick = (dropdownKey) => {


    navigate(`/app/inviteduserdetails?uid=${dropdownKey}`);
  };






  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) => {
      const invited = prev?.invited ?? [];
      const alreadySelected = invited.includes(id);

      return {
        ...prev,
        invited: alreadySelected
          ? invited.filter((e) => e !== id)
          : [...invited, id],
      };
    });
  };



       const handleShare = () => {
           const dataToExport = currentUsers.map((user) => {
               const row = { Group: user.group };
   
               if (permission.includes("adduser")) {
                   row["First Name"] = user.firstName;
                   row["Last Name"] = user.secondName;
                   row["Email"] = user.email;
               }
   
               return row;
           });
   
           const worksheet = XLSX.utils.json_to_sheet(dataToExport);
           const workbook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(workbook, worksheet, "invited Users");
   
           const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
           const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
           saveAs(blob, "invited_users.xlsx");
       };
           useEffect(() => {
               if (onExportRef) {
                   onExportRef.current = handleShare;
               }
           }, [onExportRef, currentUsers, permission]);


  const handleSelectAll = () => {
    const visibleIds = filteredUsers.map((user) => user.id);

    setSelectedIds((prev) => {
      const invited = prev?.invited ?? [];
      const allSelected = visibleIds.every((id) => invited.includes(id));

      return {
        ...prev,
        invited: allSelected
          ? invited.filter((id) => !visibleIds.includes(id))
          : [...new Set([...invited, ...visibleIds])],
      };
    });
  };

  const toggleDropdown = (id) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };


  return (
    <div className="flex-1 relative  overflow-x-autopx-4 py-4" ref={dropdownRef}>


      <div className="relative w-full ">
        <table className="w-full table-fixed text-sm text-left text-gray-900">
          <thead className="text-xs bg-gray-200 uppercase">
            <tr >
              <th className="w-8 p-2">
                <input
                  type="checkbox"
                  checked={
                    filteredUsers.length > 0 &&
                    filteredUsers.every((u) => (selectedIds.invited ?? []).includes(u.id))
                  }
                  onChange={handleSelectAll}
                className="w-4 h-4" style={{ accentColor: '#900028' }}
                />
              </th>
              {permission.includes("adduser") && (
                <>
                  <th className="w-24 px-2 py-2">First Name</th>
                  <th className="w-24 px-2 py-2">Last Name</th>
                  <th className="w-24 px-2 py-2 truncate">Email</th>
                </>
              )}
              <th className="w-10 px-2 py-2">Group</th>
              <th className="w-20 px-2 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user) => {
              const dropdownKey = user.id;
              return (
                <tr key={dropdownKey} className="border-b hover:bg-gray-50 text-xs h-5">
                  <td className="p-2">
                    <input
                      type="checkbox"
                      checked={(selectedIds.invited ?? []).includes(user.id)}
                      onChange={() => handleCheckboxChange(user.id)}
                     className="w-4 h-4" style={{ accentColor: '#900028' }}
                    />
                  </td>
                  {permission.includes("adduser") && (
                    <>
                      <td className="px-2 py-1 truncate"> {user.firstName?.charAt(0).toUpperCase() + user.firstName?.slice(1)}</td>
                      <td className="px-2 py-1 truncate"> {user.secondName?.charAt(0).toUpperCase() + user.secondName?.slice(1)}</td>
                      <td className="px-2 py-1 truncate">{user.email}</td>
                    </>
                  )}
                  <td className="px-2 py-1 truncate">{user.group}</td>
                  <td className="px-2 py-1 text-center relative" >
                    <div className="inline-block text-left" >
                      <button
                        className="text-gray-600 hover:bg-gray-200 p-1 rounded"
                        onClick={() => toggleDropdown(dropdownKey)}
                      >
                        &#x22EE;
                      </button>
                      {activeDropdown === dropdownKey && (
                        <div className="absolute right-0 z-10 mt-2 w-20 bg-white border ">
                          <button
                            className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-gray-100"
                            onClick={() => handleViewClick(user.id)}
                          >
                            View
                          </button>
                          <button
                            className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-gray-100"
                            onClick={() => handleDeleteClick(dropdownKey)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
          {loading && <LoadingSpinner />}
      </div>


      {/* Pagination */}
      <div className="flex justify-center items-center mt-4 gap-1">
        {(() => {
          const maxVisible = 6;
          let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
          let end = start + maxVisible - 1;
          if (end > totalPages) {
            end = totalPages;
            start = Math.max(1, end - maxVisible + 1);
          }

          const pages = [];
          for (let i = start; i <= end; i++) {
            pages.push(
              <button
                key={i}
                onClick={() => setCurrentPage(i)}
                className={`px-3 py-1 text-sm rounded ${currentPage === i
                  ? "font-bold text-black"
                  : "text-gray-700 hover:bg-gray-200"
                  }`}
              >
                {i}
              </button>
            );
          }
          return pages;
        })()}
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 flex items-center ${currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "hover:bg-gray-100"
            }`}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
            <h3 className="text-xl font-semibold mb-4">Confirm Delete</h3>
            <p className="mb-6">Are you sure you want to delete this invited user?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={cancelDelete}
                className="px-4 py-2 rounded bg-gray-300 text-black hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
              >
                Delete
               {loading && <LoadingSpinner />}
              </button>
            </div>
          </div>
        </div>
      )}

  
    </div>

  );

}

export default InvitedUsers;




